import { CommunicationProvider } from "@/lib/CommunicationWrapper"
import { useSearchParams } from "react-router-dom";
import { ClaimTrial, ClaimTrialBulletPoints, ClaimTrialContent } from "./Claim";
import { TrialStartContent } from "./Start";
import { useAuth } from "@/lib/auth";
import { UpgradeContent } from "./Upgrade";
import { useEffect, useState } from "react";


// start = immediately start the trial. no claim button needed.
// claim = show the claim button. trial does not auto start.

export const highlights = {
    "auto_rotate_theme": {
        "title": "Auto-rotate your theme with",
        "keywords": "automatic theme rotation",
        "type": "start",
        "tier": "style",
    },
    "assignments_upsert": {
        "title": "Plan unlimited tasks with",
        "keywords": "unlimited task planning",
        "type": "start",
        "tier": "learn",
    },
    "assignments_auto_schedule": {
        "title": "Auto-plan assignments with",
        "keywords": "assignment auto-plan",
        "type": "start",
        "tier": "learn",
    },
    "assignments_due_view": {
        "title": "Plan unlimited tasks with",
        "keywords": "unlimited task planning",
        "type": "claim",
        "tier": "learn",
    },
    "grades_whatif": {
        "title": "Calculate assignment GPA with",
        "keywords": "assignment GPA calculator",
        "type": "claim",
        "tier": "learn",
    },
    "theme_creations": {
        "title": "Create more themes with",
        "keywords": "theme creations",
        "type": "claim",
        "tier": "style",
    },
    "agenda_date_change": {
        "title": "Change agenda date with",
        "keywords": "agenda date changing",
        "type": "start",
        "tier": "learn",
    },
    "assignments_calendar_date_change": {
        "title": "See more tasks with",
        "keywords": "calendar date navigation",
        "type": "start",
        "tier": "learn",
    },
    "timerSettings": {
        "title": "Set timer settings with",
        "keywords": "timer settings",
        "type": "start",
        "tier": "learn",
    },
    "transcript": {
        "title": "Get more lecture transcriptions with",
        "keywords": "lecture transcriptions",
        "type": "start",
        "tier": "learn",
    },
    "calendarSync": {
        "title": "Sync your calendar with",
        "keywords": "calendar syncing",
        "type": "claim",
        "tier": "learn",
    },
    "themeSwapLimit": {
        "title": "Get more theme swaps with",
        "keywords": "theme swapping",
        "type": "claim",
        "tier": "style",
    },
    "study_files": {
        "title": "Get more file uploads with",
        "keywords": "",
        "type": "claim",
        "tier": "learn"
    }
}

export const highlightTitles = {
    "auto_rotate_theme": "Auto-rotate your theme with",
    "assignments_upsert": "Plan unlimited tasks with",
    "assignments_auto_schedule": "Auto-plan assignments with",
    "assignments_due_view": "Plan unlimited tasks with",
    "grades_whatif": "Calculate assignment GPA with",
    "agenda_date_change": "Change agenda date with",
    "assignments_calendar_date_change": "See more tasks with",
    "timerSettings": "Set timer settings with",
    "transcript": "Get more lecture transcriptions with",
    "calendarSync": "Sync your calendar with",
    "themeSwapLimit": "Get more theme swaps with",
    "study_files": "Get more file uploads with"
}

export type HighlightType = "start" | "claim";
export type TierType = "style" | "learn";
export type Highlight = {
    title: string;
    keywords: string;
    type: HighlightType;
    tier: TierType;
}
export type HighlightKey = keyof typeof highlights;


export const TrialGateContent = () => {

    const [initialTrialState, setInitialTrialState] = useState({
        usedTrial: true
    });

    const { authUser } = useAuth();
    const usedTrial = authUser?.app_metadata?.used_trial;

    useEffect(() => {
        setInitialTrialState({
            usedTrial: usedTrial
        });
    }, []);

    if (true) return <ClaimTrialBulletPoints />

    // Always show the upgrade screen instead of trial claim/start
    return <ClaimTrial />
}

const ab = "b";

export const TrialGate = () => {

    const [searchParams] = useSearchParams();
    const highlight = searchParams.get("highlight");

    return (
        <CommunicationProvider>
            {ab === "a" ? <ClaimTrialContent highlight={highlight} /> : <ClaimTrialBulletPoints highlight={highlight}/>}
        </CommunicationProvider>
    )
}